<i18n>
{
"en": {
  "MESSAGES": "Messages",
  "LOADOLDERMESSAGES": "Load Older Messages",
  "ATTACHEMENT": "Attachement",
  "REPLY": "Reply",
  "WRITEYOURMESSAGE": "Write your message",
  "LOADING": "Loading...",
  "FILESWITHASIZELESSTHAN": "Files with a size less than 400kb",
  "SENDING": "Sending...",
  "NOW": "just now",
  "GROUPSUPERVISOR": "To: Type the name of a bus supervisor",
  "NEWMESSAGE": "New Message",
  "TO": "to ",
  "SUCCESS": "Message has been sent to supervisor(s)!",
  "ERROR": "Error",
  "CLOSE": "Close",
  "FILEISTOOLARGERMAXFILEIS": "File is too large, max file is {len}.",
  "TYPEERROR": "File extensions should be {len}."   
},
"ar": {
  "MESSAGES": "رسائل",
  "LOADOLDERMESSAGES": " تحميل رسائل قديمة",
  "ATTACHEMENT": "المرفق",
  "REPLY": "الرد",
  "WRITEYOURMESSAGE": "اكتب رسالتك",
  "LOADING": "جار التحميل...",
  "FILESWITHASIZELESSTHAN": " 400 KB الملفات بحجم أقل من",
  "SENDING": "...إرسال",
  "NOW": "الآن",
  "GROUPSUPERVISOR": "إلى: اكتب اسم مشرف الحافلة",
  "NEWMESSAGE": "رسالة جديدة",
  "TO": "إلى ",
  "SUCCESS": "تم إرسال رسالة إلى المشرف (المشرفين)!",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "FILEISTOOLARGERMAXFILEIS": "ملحقات الملفات يجب أن تكون {len}.",
  "TYPEERROR": "ملحقات الملفات يجب أن تكون {len}."    
}
}
</i18n>
<template>
  <div class="form" id="conversation">
    <el-card  class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <el-row type="flex" align="bottom">
          <el-col :span="6">
            <span style="line-height: 36px;">{{$t('MESSAGES')}} </span>
            <el-button v-if="isAllowed('send', 'report/message')" @click="newMessage()" type="text"><i class="fa fa-pencil-square-o fa-2x"></i> </el-button>
          </el-col>
          <el-col v-show="monitorInput" :span="18" class="padding1">
            <el-select ref="gmonitor" value-key="BusMonitorID" v-model="selectedMonitors" filterable multiple @change="handleSelect()" :placeholder="$t('GROUPSUPERVISOR')">
              <el-option
                :key="key"
                v-for="(item, key) in supervisors"
                :label="_FullName({NameEN: item.FullName_EN, NameAR: item.FullName_AR})"
                :value="item">
              </el-option>
            </el-select>        
          </el-col>
        </el-row>
      </div>
      <el-row  v-loading="loading" :element-loading-text="$t('LOADING')">
        <el-col :span="6">
          <el-tabs type="border-card"  v-bind:style="{ height: cardHeight + 'px' }">
            <VuePerfectScrollbar style="margin:-15px; margin-top:-14px" v-bind:style="{ height: cardHeight + 'px' }">
              <div>
                <el-button class="list" :key="key" v-for="(message, key) in messages" @click="loadConversation(key)" v-bind:class="[key==conversation ? 'active' : '']">
                  <div v-if="key == 0 && selectedMonitors.length > 1" style="overflow: hidden" class="img-circle">
                    <div :key="index" v-for="(item, index) in selectedMonitors" v-if="index < 3" style="box-sizing: border-box;overflow: hidden;" class="pull-left" :style="{width: imageWidth/(selectedMonitors.length < 3 ? selectedMonitors.length : 3) + 'px'}">
                      <img :src="getAsset(item.ImagePath, 'supervisor')" alt="" width="50" height="50" :style="{marginLeft: -24/(selectedMonitors.length < 3 ? selectedMonitors.length : 3) + 'px'}">
                    </div>
                  </div>
                  <img v-else :src="getAsset(message.monitor.ImagePath, 'supervisor')"  class="img-circle">
                  <div style="display: flex;">
                    <span style="flex: 1 1 0%;min-width: 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{_FullName({NameEN: message.monitor.FullName_EN, NameAR: message.monitor.FullName_AR})}}</span>
                    <el-badge v-if="messageCount(message) && key != 0" ><sup  ref="badge" class="el-badge__content">{{message.count}}</sup></el-badge>
                    <i v-if="key == 0" @click.stop="deleteNewMessage()" class="el-icon-close"></i>
                  </div>
                </el-button>
              </div>   
            </VuePerfectScrollbar>
          </el-tabs>
        </el-col>
        <el-col :span="18" style="overflow: hidden;background:#ddd"   v-bind:style="{ height: cardHeight + 'px' }" v-loading="loading_board" :element-loading-text="$t('LOADING')">
          <VuePerfectScrollbar  ref="Scrollbar" class="scrollbar" v-bind:style="{ height: boardHeight + 'px' }">
            <div style="padding:20px" ref="messages">
              <div align="center" style="margin-bottom: 20px">
                <el-button v-show="isMore(messages[conversation])" @click="loadOlderMessages">{{$t('LOADOLDERMESSAGES')}} <i class="fa fa-angle-double-up"></i> </el-button>
              </div>
              <el-card style="margin-bottom:10px !important;"  :key="index" v-for="(item, index) in orderedConversations()" >
                <div class="media-left">
                  <img  class="img-circle" style="width: 50px" v-bind:src="getAsset(item.ImagePath, item.FullName_EN == 'School' ? 'configuration' :'supervisor', item.FullName_EN == 'School')" />
                </div>
                <div class="media-body">
                  <h4 class="media-heading">{{_FullName({NameEN: item.FullName_EN, NameAR: item.FullName_AR})}} <small class="pull-right"><i class="fa fa-calendar"></i> {{item.datetime}}</small></h4>
                  {{item.Text}}
                </div>
                <div class="media-footer">
                  <el-button type="text" @click="showAttachment(item.FileName, item.FileType)" v-if="item.FileName" class="pull-right fa fa-download"></el-button>
                </div>
              </el-card>
            </div>
          </VuePerfectScrollbar>
          <el-card ref="formCard" style="border-width:0; border-top-width:1px; border-left-width:1px">
            <el-input
              type="textarea"
              ref="msgInput"
              :rows="2"
              :disabled="!isAllowed('send', 'report/message')"
              :placeholder="$t('WRITEYOURMESSAGE')"
              v-model="compose.Text">
            </el-input>
            <el-row style="margin-top:15px">
              <el-col :span="8">
                <el-upload
                        :before-upload="beforeUpload"
                        :on-success="updateFile"
                        :on-progress="limitFile"
                        :disabled="!isAllowed('send', 'report/message')"
                        :headers="{'Accept-Language': currentLang(), 'X-API-KEY': API_KEY}"
                        :with-credentials="true"
                        :action="URL + 'media/upload'"
                        :data="{folder: folder, type: 'attachment'}"
                        >
                    <el-button :disabled="!isAllowed('send', 'report/message')" size="small" type="warning"><i class="fa fa-paperclip"></i> {{$t('ATTACHEMENT')}}</el-button>
                    <div slot="tip" class="el-upload__tip">{{$t('FILESWITHASIZELESSTHAN')}} </div>
                </el-upload>
              </el-col>
              <el-col v-if="compose.Attachment.Filename" :span="10" style="float: left;">{{compose.Attachment.Filename}}</el-col>
              <el-col :span="compose.Attachment.Filename ? 6 : 16"><el-button class="reply" style="margin-top:15px" :disabled="validateReply()" @click="replyConversation()" type="primary">{{loadingSend ? $t('SENDING') : $t('REPLY')}}</el-button></el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  <el-doc-dialog :visible.sync="imageVisible" :document="imageSrc" title="ATTACHEMENT" subFolder="messages"></el-doc-dialog>     
  <el-dialog :title="$t('ERROR')" v-model="error" size="tiny">
    <div class="el-alert el-alert--error">
      <i class="el-alert__icon el-icon-circle-cross is-big"></i>
      <div class="el-alert__content">
        <span class="el-alert__title is-bold" :key="index" v-for="(messageError, index) in errorMessage" v-html="printError(messageError)"></span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
    </span>
  </el-dialog>  
  </div>
</template>
<script>
  
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import { EventBus } from '../../event-bus.js'
  import DocDialog from '@/components/dialogs/Doc'
  import lodash from 'lodash'
  export default {
    components: {VuePerfectScrollbar, lodash, 'el-doc-dialog': DocDialog},
    data () {
      return {
        messages: {},
        message: null,
        errorMessage: null,
        compose: {Recipient: null, RecipientID: null, Text: null, hasAttachment: false, ClassID: null, Attachment: {Filename: null, type: null}, parentID: null, threadID: null, groupTextID: null},
        conversation: null,
        conversations: [],
        supervisors: [],
        loading_board: true,
        currentPage: 1,
        limit: 20,
        offset: 0,
        cardHeight: 0,
        boardHeight: 0,
        loading: true,
        more: true,
        error: false,
        imageVisible: false,
        imageSrc: [],
        loadingSend: false,
        school_id: null,
        monitorInput: false,
        selectedMonitors: [],
        imageWidth: 50,
        fileList: [],
        folder: null
      }
    },
    computed: {
      sortedMessages () {
        let orderedMsgs = {}
        if (lodash.isEmpty(this.messages)) return {}
        let messages = this.messageSort(this.messages)
        for (let index in messages) {
          let key = messages[index]
          orderedMsgs[key] = this.messages[key]
        }
        return orderedMsgs
      }
    },
    mounted () {
      this.switchLanguage()
      let userData = JSON.parse(localStorage.getItem('userData'))
      this.folder = this.$route.path.split('/')[2]
      this.school_id = userData.school_id
      this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.boardHeight = this.cardHeight - this.$refs.formCard.$el.offsetHeight
      this.getMessages()
      this.messageNotification()
    },
    methods: {
      printError (message) {
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      messageCount (message) {
        if (this.conversation === null) {
          this.conversation = message.SenderID
          this.conversations = message.conversations
        }
        if (this.conversation === message.SenderID && message.count !== 0) {
          EventBus.messages.total -= message.count
          message.count = 0
          return false
        }
        if (message.count !== 0) return true
        return false
      },
      messageSort (messages) {
        return Object.keys(messages).sort(function (a, b) {
          let diff = parseInt(messages[b].count) - parseInt(messages[a].count)
          if (diff !== 0) return diff
          else return messages[a].origOrder - messages[b].origOrder
        })
      },
      beforeUpload (file) {
        const isJPG = file.type.split('/')[0] === 'image' || file.type.split('/')[1] === 'pdf' || file.type.split('/')[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type.split('/')[0] === 'text'
        const isLt2KB = file.size / 1024 < 400
        this.errorMessage = {}
        if (!isJPG) {
          this.errorMessage['type'] = ' TYPEERROR png,gif,jpeg,jpg,pdf,doc,docx,txt'
        }
        if (!isLt2KB) {
          this.errorMessage['size'] = ' FILEISTOOLARGERMAXFILEIS 400KB'
        }
        if (Object.keys(this.errorMessage).length !== 0) this.error = true
        return isJPG && isLt2KB
      },
      newMessage () {
        if (this.monitorInput) return (this.$nextTick(this.$refs.gmonitor.$el.children[1].children[1].focus()))
        this.getSupervisors()
        let message = {SenderID: 0, more: false, count: 0, conversations: [], monitor: {}}
        this.selectedMonitors.length = 0
        this.monitorInput = true
        message.monitor.BusMonitorID = ''
        message.monitor.FullName_EN = this.$t('NEWMESSAGE', 'en')
        message.monitor.FullName_AR = this.$t('NEWMESSAGE', 'ar')
        message.monitor.ImagePath = null
        this.$set(this.messages, 0, message)
        this.loadConversation(0)
        this.$nextTick(function () { this.$refs.gmonitor.$el.children[1].children[1].focus() })
      },
      deleteNewMessage () {
        this.$delete(this.messages, 0)
        this.selectedMonitors = []
        this.loadConversation(Object.keys(this.messages)[0])
        this.monitorInput = false
      },
      validateReply () {
        if (this.monitorInput && this.conversation === 0) {
          if (lodash.isEmpty(this.selectedMonitors)) return true
        }
        if (lodash.isEmpty(this.compose.Text)) return true
        return false
      },
      showAttachment (name, type) {
        this.imageSrc = [{file_name: name, label: type}]
        this.imageVisible = true
      },
      getMessages () {
        let endPoint = '/message?limit=' + this.limit + '&offset=0'
        if (this.$route.params.id) endPoint += '&BusMonitorID=' + this.$route.params.id
        let self = this
        this.$http.get(endPoint).then(function (response) {
          self.loading = false
          self.loading_board = false
          self.messages = response.data
          if (self.$route.params.id) self.loadConversation(self.$route.params.id)
          self.scrollDown()
        }).catch(function (response) {})
      },
      handleSelect () {
        let selectedNameEN = this.$t('NEWMESSAGE', 'en') + ' '
        let selectedNameAR = this.$t('NEWMESSAGE', 'ar') + ' '
        let i = 1
        let imagePath = ''
        for (let key in this.selectedMonitors) {
          let monitor = this.selectedMonitors[key]
          if (lodash.isEmpty(monitor)) break
          imagePath = monitor.ImagePath
          if (i === 1) {
            selectedNameEN += this.$t('TO', 'en')
            selectedNameAR += this.$t('TO', 'ar')
          }
          selectedNameEN += monitor.FullName_EN
          selectedNameAR += monitor.FullName_AR
          if (this.selectedMonitors.length !== i) {
            selectedNameEN += ', '
            selectedNameAR += ', '
          }
          i++
        }
        this.$refs.gmonitor.query = ''
        if (this.messages[0] === undefined) return
        this.messages[0].more = true
        this.messages[0].monitor = {FullName_EN: selectedNameEN, FullName_AR: selectedNameAR, ImagePath: this.selectedMonitors.length === 1 ? imagePath : undefined}
        this.loadConversation(this.selectedMonitors.length === 1 ? this.selectedMonitors[0].BusMonitorID : 0, true)
        if (this.selectedMonitors.length !== 1) this.messages[0].more = false
      },
      loadOlderMessages () {
        let counterMsg = this.messages[this.conversation].conversations.length
        let Timestamp = this.messages[this.conversation].conversations[counterMsg - 1].Timestamp
        let BusMonitorID = this.conversation === 0 && this.selectedMonitors.length === 1 ? this.selectedMonitors[0].BusMonitorID : this.conversation
        let self = this
        let params = {limit: self.limit, offset: self.offset, BusMonitorID: BusMonitorID, Timestamp: Timestamp}
        this.$http.get('/message/conversation', {params: params}).then(function (response) {
          let messages = response.data
          if (messages.length === undefined) {
            self.messages[self.conversation].more = false
            return
          }
          for (let item in messages) {
            self.messages[self.conversation].conversations.push(messages[item])
          }
          self.conversations = self.messages[self.conversation].conversations
        }).catch(function (response) {
        })
      },
      loadConversation (BusMonitorID, from = false) {
        this.conversation = !from ? BusMonitorID : 0
        if (!from) {
          if (this.messages[this.conversation].count !== 0) EventBus.messages.total -= this.messages[this.conversation].count
          this.messages[this.conversation].count = 0
          if (this.messages[this.conversation].conversations.length !== 0) {
            this.conversations = this.messages[this.conversation].conversations
            this.scrollDown()
            return
          }
        }
        if (BusMonitorID === 0) {
          this.messages[this.conversation].conversations = []
          this.conversations = []
          return
        }
        this.loading_board = true
        let self = this
        this.$http.get('/message/conversation', {params: {BusMonitorID: BusMonitorID}})
          .then(function (response) {
            self.messages[self.conversation].conversations = response.data
            self.conversations = response.data
            self.loading_board = false
            self.scrollDown()
          }).catch(function (response) {
          })
      },
      scrollDown () {
        this.$nextTick(function () {
          this.$refs.msgInput.$el.children[0].focus()
          this.$refs.Scrollbar.$el.scrollTop = this.$refs.messages.offsetHeight
          this.$refs.Scrollbar.update()
        })
      },
      messageNotification () {
        EventBus.$on('message', message => {
          let monitorMessage = {
            ReceiverID: this.school_id,
            Sender: message.SenderID,
            MessageID: null,
            Timestamp: message.Timestamp,
            datetime: message.datetime,
            MessageTextID: null,
            Text: message.Text,
            FullName_EN: message.monitor.FullName_EN,
            FullName_AR: message.monitor.FullName_AR,
            FileName: message.FileName,
            FileType: message.FileType,
            ImagePath: message.monitor.ImagePath}
          if (this.messages[message.SenderID] === undefined) {
            let monitor = lodash.pick(monitorMessage, ['ImagePath', 'FullName_EN', 'FullName_AR'])
            monitor.BusMonitorID = message.SenderID
            this.$set(this.messages, message.SenderID, {SenderID: message.SenderID, more: false, count: 0, conversations: [], monitor: monitor})
          }
          if (this.messages[message.SenderID].conversations.length !== 0) this.messages[message.SenderID].conversations.push(monitorMessage)
          this.messages[message.SenderID].count++
          this.messages = this.sortedMessages
        })
      },
      orderedConversations () {
        if (this.conversations.length > 0) return lodash.orderBy(this.conversations, 'MessageID')
      },
      isSet (message, property) {
        if (message === undefined) return false
        if (property in message) return true
        return true
      },
      isMore (messages) {
        if (!this.isSet(messages, 'more')) return false
        if (messages.more) return true
        return false
      },
      replyConversation () {
        let date = new Date()
        let Timestamp = this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
        let BusMonitorID = (this.conversation === 0) ? this.getSelectedSupervisors() : this.messages[this.conversation].monitor.BusMonitorID
        let message = {
          ReceiverID: BusMonitorID,
          Sender: this.school_id,
          MessageID: null,
          Timestamp: Timestamp,
          datetime: this.$moment(date).format('DD/MM/YYYY HH:mm'),
          MessageTextID: null,
          Text: this.compose.Text,
          Attachment: this.compose.Attachment,
          HasAttachment: 0,
          FileName: this.compose.Attachment.Filename,
          FullName_EN: 'School',
          FullName_AR: 'مدرسة',
          ImagePath: null}
        this.compose.Recipient = 6
        this.compose.RecipientID = BusMonitorID
        let postData = {message: this.compose}
        let self = this
        self.loadingSend = true
        this.$http.post('/message/send', postData).then(function (response) {
          if (!response.data.error) {
            message.MessageID = response.data.MessageID
            self.compose.Text = null
            self.compose.Attachment.Filename = null
            if (self.conversation === 0) self.pushGroupMessages(message, response.data.message)
            else self.messages[self.conversation].conversations.push(message)
          }
          self.scrollDown()
          self.loadingSend = false
        }).catch(function () {
        })
      },
      getSelectedSupervisors () {
        let monitors = []
        this.selectedMonitors.forEach(function (item) {
          monitors.push(item.BusMonitorID)
        })
        return monitors
      },
      pushGroupMessages (message, response) {
        for (let key in this.selectedMonitors) {
          let monitor = this.selectedMonitors[key]
          if (this.messages[monitor.BusMonitorID] === undefined) continue
          if (this.messages[monitor.BusMonitorID].conversations.length !== 0) {
            message.ReceiverID = monitor.BusMonitorID
            this.messages[monitor.BusMonitorID].conversations.push(message)
          }
        }
        this.deleteNewMessage()
        return this.$message({
          message: this.$t(response),
          type: 'success',
          showClose: true
        })
      },
      getSupervisors () {
        let self = this
        if (self.supervisors.length !== 0) return
        this.$http.get('/supervisor').then(function (response) {
          self.supervisors = response.data
        }).catch(function (response) {})
      },
      updateFile (response, file, fileList) {
        this.compose.hasAttachment = true
        this.compose.Attachment.Filename = response.file_name
        this.compose.Attachment.type = file.raw.type
      },
      handleRemove (file, fileList) {
        this.compose.hasAttachment = false
        this.compose.Attachment.Filename = file.name
        file = []
      },
      limitFile (event, file, fileList) {
        if (fileList.length > 1) fileList.splice(0, 1)
      },
      getSchoolPhoto (image) {
        if (image === undefined) return this.BASEURL + 'uploads/thumbnails/no-school.png'
        image = image !== null && image !== '' ? image : 'no-school.png'
        return this.BASEURL + 'uploads/thumbnails/' + image
      },
      getAttachment (image) {
        return this.BASEURL + 'uploads/messages/' + image
      },
      directionScroll (e) {
      }
    }
  }
</script>

<style>
#rtl #conversation .el-button.reply {float: left;}
#conversation .el-button.reply {float: right;}
#conversation .el-autocomplete .inline-input {width:100%}
#conversation .el-select .el-input input {border-radius: 0;border-width: 0px;}
#conversation .list .el-icon-close{visibility: hidden;display: block;float:right;padding-right: 5px;}  
#rtl #conversation .list .el-icon-close{visibility: hidden;display: block;float:left;padding-left: 5px;padding-right: 0px} 
#conversation button.list.active:hover .el-icon-close, #rtl #conversation button.list.active:hover .el-icon-close{visibility:visible;}
#conversation .clearfix .padding1 {padding-left:20px}
#rtl #conversation .clearfix .padding1 {padding-right:20px}
</style>




// WEBPACK FOOTER //
// Message.vue?7b01249e